// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"437":"d1002af2","543":"c8fec544","553":"6ff224e4","680":"8976e618","715":"c8d84403","768":"4c2e008d","876":"dc347163","881":"9776150a"}[chunkId] + ".chunk.js";
};